<template>
    <section class="team-edit-view">
        <div class="modal-header">
            <h3 v-if="team.id">Edit Team</h3>
            <h3 v-else>Add Team</h3>
        </div>
        <app-form v-model="team" @submit.native.prevent="submit">
            <app-form-item label="Name" prop="name">
                <app-input id="name" v-model="team.name" autofocus/>
            </app-form-item>
            <app-form-item label="Tag" prop="tag">
                <app-input id="tag" v-model="team.tag" name="tag"/>
            </app-form-item>
            <app-form-item prop="team.visibility">
                <div slot="label">
                    Visibility
                    <app-tooltip placement="top">
                        <div slot="content">
                            <strong>Private</strong>: Only you and attached users can view the group
                            <br>
                            <strong>Public</strong>: Everyone under you can see the group
                        </div>
                        <i class="app-icon icon-info"/>
                    </app-tooltip>
                </div>
                <app-radio-group v-model="team.visibility">
                    <app-radio :label="1">Public</app-radio>
                    <app-radio :label="0">Private</app-radio>
                </app-radio-group>
            </app-form-item>

            <app-collapse-item title="Advanced Settings" name="1">
                <app-form-item label="Is A Sport" prop="team.is_sport">
                    <app-switch
                        v-model="team.is_sport"
                        active-text="Yes"
                        inactive-text="No"/>
                </app-form-item>
            </app-collapse-item>

            <div class="modal-footer">
                <app-button
                    v-if="team.id"
                    :border="false"
                    type="danger"
                    size="large"
                    tabindex="1"
                    style="float:left"
                    plain
                    @click="remove">Delete</app-button>
                <app-button
                    :loading="isSaving"
                    type="primary"
                    native-type="submit"
                    size="large">Save</app-button>
            </div>
        </app-form>
    </section>
</template>
<script>
import Team from '@/store/models/Team'

export default {
    name: 'team-detail-edit',
    inject: ['modalOptions'],
    props: {
        team_id: Number
    },
    data() {
        return {
            team: Team.$cloneOrNew(this.team_id),
            isSaving: false,
            advancedSettings: []
        }
    },
    methods: {
        submit() {
            // Update if there is an id, else create
            this.team.id ? this.update() : this.create()
        },
        create() {
            this.isSaving = true
            this.team.$create()
                .then( team => {
                    this.isSaving = false
                    this.modalOptions.modalOpen = false
                    this.$router.push({
                        name: 'teams.detail',
                        params: { uuid: team.data.uuid }
                    })
                })
                .catch(() => {
                    this.isSaving = false
                })

            return false
        },
        update() {
            this.isSaving = true
            this.team.$update()
                .then(() => {
                    this.isSaving = false
                    this.modalOptions.modalOpen = false
                })
            return false
        },
        remove() {
            this.$confirm({
                title: 'Confirm',
                message:
                    'Are you sure you want to remove this team? All students in it will no longer be assigned to a team.'
            })
                .then(() => {
                    return this.team.$remove()
                })
                .then(() => {
                    this.$router.push({ name: 'teams' })
                })
        }
    }
}
</script>

<style lang="stylus"></style>
